import React from 'react';
import '../css/ProjectsTips.css';

function ProjectsTips({ image, title, demoLink, codeLink, paragraph, made1,made2,made3,made4 }) {
    return (
        <div className="col">
            <div className="image">
                <img src={image} alt="" />
            </div>
            <div className="project__title">
                <h1 className="animate__animated animate__shakeX animate__infinite animate__slow">{title}</h1>
                <div className="links">
                    <a href={demoLink} target="_blank">Demo</a>
                    <a href={codeLink} target="_blank">Code</a>
                </div>

            </div>
            <div className="project__description"><p>{paragraph}</p></div>
            <div className="project__tools">
                <p>{made1}</p>
                <p>{made2}</p>
                <p>{made3}</p>
                <p>{made4}</p>
            </div>
        </div>
    )
}

export default ProjectsTips
